import { tabletQuery } from '@globals/themes/themeConstants'
import Stack, { StackProps } from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ReactNode } from 'react'

type FormActionTrayProps = StackProps & {
  children: ReactNode | ReactNode[]
  errors?: ReactNode
  mt?: number
}

const FormActionTray: React.FC<FormActionTrayProps> = ({
  errors,
  children,
  mt = 3,
  ...restProps
}) => {
  const isTablet = useMediaQuery(tabletQuery)

  return (
    <>
      {errors}
      <Stack
        direction={isTablet ? 'column-reverse' : 'row'}
        spacing={2}
        {...restProps}
        sx={[
          {
            justifyContent: 'flex-end',
            mt: mt,
            zIndex: 1,
          },
          ...(Array.isArray(restProps.sx) ? restProps.sx : [restProps.sx]),
        ]}>
        {children}
      </Stack>
    </>
  )
}

export default FormActionTray
